import React from 'react';
import { Query } from '@apollo/client/react/components';

import CurrentUserRanksQuery from 'buyside/graphql/queries/currentUserRanks';

import CurrentUserRankInfo from 'buyside/components/presentation/RankingsIndexPage/currentUserRankInfo/CurrentUserRankInfo';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

const CurrentUserRanksContainer = ({ category }) => {
  const isMobile = useIsMobile();

  return (
    <Query query={CurrentUserRanksQuery}>
      {({ loading, data }) => {
        if (loading || !data) {
          return <LoadingSpinner size={SIZES.MEDIUM} />;
        }
        const {
          currentUser: { currentRanks }
        } = data;
        const currentUserRank = currentRanks.filter(rank => rank.category === category)[0];
        if (currentRanks.length) {
          return (
            <CurrentUserRankInfo
              currentRanks={currentRanks}
              currentUserRank={currentUserRank}
              category={category}
              isMobile={isMobile}
            />
          );
        }
        return null;
      }}
    </Query>
  );
};

export default CurrentUserRanksContainer;
